/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import {
  GETMARKETTYPE,
  GETMARKETLIST,
  GETPERIOD,
  GETMARKETRECORD,
  GETMARKETSCALELIST,
  GETMARKETSUM,
} from './constants'
import { getCurrentTimeByType } from '../../util'

export const getMarketType = (payload) => {
  return {
    type: GETMARKETTYPE,
    payload,
  }
}
export const getMarketList = (payload) => {
  return {
    type: GETMARKETLIST,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}
export const getMarketRecord = (payload) => {
  return {
    type: GETMARKETRECORD,
    payload,
  }
}
export const getMarketScaleList = (payload) => {
  return {
    type: GETMARKETSCALELIST,
    payload,
  }
}
export const getMarketSumNum = (payload) => {
  return {
    type: GETMARKETSUM,
    payload,
  }
}
//所有,普通,非普通,商品
export function fetchMarketList(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/BusinessApi/SoldRecordsAll`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getMarketList(data.data.list))
      dispatch(getMarketSumNum(data.data.incomeSum))
      return data
    })
  }
}

// 销售记录
export function fetchMarketScaleList(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/BusinessApi/SoldRecordsAll`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getMarketScaleList(data.data.list))
    })
  }
}

//商品分类
export function fetchClubCommodityType() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/CommodityTypeList`
    return fetchData(endpoint).then((data) => {
      dispatch(getMarketType(data))
      return data
    })
  }
}
//销售记录
export function fetchMarketRecord(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/CommodityBusiness`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === false) {
        message.info(data.detail)
      } else {
        dispatch(getMarketRecord(data))
      }
      return data
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    return dispatch(getPeriod(getCurrentTimeByType(type)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubMarket/action.js